import script from "./ReferralEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralEvent.vue?vue&type=script&setup=true&lang=js"

import "./ReferralEvent.vue?vue&type=style&index=0&id=44677ab8&lang=scss"

const __exports__ = script;

export default __exports__